import { UseScriptResult, useScript } from './useScript';

export function useGooglePickerScript(): UseScriptResult {
  return useScript('https://apis.google.com/js/api.js');
}
